import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './text-editor-toolbar.scss';

const TextEditorToolbar = ({ children, theme = {} }) => {
  const containerClassName = classNames(styles.container, theme.container);
  return (
    <div className={containerClassName} style={theme.containerStyle}>
      {children}
    </div>
  );
};

TextEditorToolbar.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
};

export default TextEditorToolbar;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-toolbar.js